/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
import { useState, useCallback, useEffect, useContext, useRef, Suspense } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import getAgGridHeight from "../../../../../../utils/commonFunctions/getAgGridHeight";
import CustomGridDialog from "../../../../../shared/dialogs/customGridDialog/CustomGridDialog";
import { AuthContext } from "../../../../../../contexts";
import ROLES from "../../../../../../constants/roles";

import { Button } from "@material-ui/core";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { PersonalChangeRequestsGridProps } from "../../../../../../@types/components/changeRequestsProps.type";
import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import { Member } from "../../../../../../@types/member.types";
import { handleDateCellRenderer } from "../../../../../../utils/commonFunctions/cellRenderers";
import { PersonalChangeRequestsByMember } from "../../../../../../@types/changeRequests.types";

const PersonalChangeRequestGrid = ({ personalChangeRequests }: PersonalChangeRequestsGridProps) => {
	const [actionDialogProps, setActionDialogProps] = useState({
		openDialog: false,
		title: "Accept All the Change Request",
		content: "",
		actions: [
			{
				label: "Confirm",
				name: "ok",
				callback: () => {
					setActionDialogProps(Object.assign({}, actionDialogProps, { openDialog: false }));
				}
			}
		]
	});
	const [checkPersonalChangeRequestDialogProps, setCheckPersonalChangeRequestDialogProps] = useState({
		openDialog: false,
		title: "Change Request for Personal Change ",
		type: "Personal Change Request",
		actions: [
			{
				label: "Reject All",
				name: "reject_all",
				callback: () => {
					setCheckPersonalChangeRequestDialogProps(
						Object.assign({}, checkPersonalChangeRequestDialogProps, { openDialog: false })
					);
				}
			},
			{
				label: "Accept All",
				name: "accept_all",
				callback: () => {
					setCheckPersonalChangeRequestDialogProps(
						Object.assign({}, checkPersonalChangeRequestDialogProps, { openDialog: false })
					);
				}
			}
		]
	});
	const [checkContactChangeRequestDialogProps, setCheckContactChangeRequestDialogProps] = useState({
		openDialog: false,
		title: "Change Request for Contact Change",
		type: "Contact Change",
		actions: [
			{
				label: "Reject All",
				name: "reject_all",
				callback: () => {
					setCheckContactChangeRequestDialogProps(
						Object.assign({}, checkContactChangeRequestDialogProps, { openDialog: false })
					);
				}
			},
			{
				label: "Accept All",
				name: "accept_all",
				callback: () => {
					setCheckContactChangeRequestDialogProps(
						Object.assign({}, checkContactChangeRequestDialogProps, { openDialog: false })
					);
				}
			}
		]
	});
	const [changePersonalRequestDialogGridData, setChangePersonalRequestDialogGridData] = useState([]);
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const [gridHeight, setGridHeight] = useState("400px");
	const agGridRef = useRef<any>(null);
	const { user } = useContext(AuthContext);

	const handleAgGridReady = (params: GridReadyEvent) => {
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, agGridAPI, api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handleOpenCheckRequestDialogClick = useCallback(() => {
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const { data } = row as { data: PersonalChangeRequestsByMember };

		setCheckPersonalChangeRequestDialogProps(
			Object.assign({}, checkPersonalChangeRequestDialogProps, { openDialog: true })
		);
		setChangePersonalRequestDialogGridData(Object.assign([], data.personal_change_requests));
	}, [checkPersonalChangeRequestDialogProps]);

	const handleCloseCheckRequestDialogClick = useCallback(() => {
		setCheckPersonalChangeRequestDialogProps(
			Object.assign({}, checkPersonalChangeRequestDialogProps, { openDialog: false })
		);
	}, [checkPersonalChangeRequestDialogProps]);

	const handleActionCellRender = useCallback(() => {
		return (
			<Button className="ag-grid-cell-button" variant="outlined" onClick={handleOpenCheckRequestDialogClick}>
				Check Request
			</Button>
		);
	}, [handleOpenCheckRequestDialogClick]);

	const handleEmployeeNameCellRenderer = ({ value }: { value: Member }) => {
		return <>{value ? <div>{value.first_name + " " + value.last_name}</div> : null}</>;
	};

	useEffect(() => {
		const _gridHeight = getAgGridHeight(personalChangeRequests.length);
		setGridHeight(_gridHeight);
	}, [personalChangeRequests.length]);

	// console.log("personalChangeRequests", personalChangeRequests);

	return (
		<>
			<Suspense fallback={<div />}>
				<CustomGridDialog
					dialogProps={checkPersonalChangeRequestDialogProps}
					rowData={changePersonalRequestDialogGridData}
					handleClose={handleCloseCheckRequestDialogClick}
				/>
			</Suspense>
			{/* <Suspense fallback={<div />}>
				<CustomGridDialog
					dialogProps={checkContactChangeRequestDialogProps}
					rowData={changeContactRequestDialogGridData}
					handleClose={handleCloseCheckRequestDialogClick}
				/>
			</Suspense> */}
			<div
				className="personal-change-request-grid-container glb-tab-grid-container"
				id="personal-change-request-grid-container"
			>
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						rowData={personalChangeRequests}
						onGridReady={handleAgGridReady}
						onFirstDataRendered={handleFirstDataRendered}
						rowSelection={"Single"}
						animateRows
						suppressColumnVirtualisation={true}
						defaultColDef={{
							filter: "agTextColumnFilter",
							floatingFilter: true,
							resizable: true
						}}
						frameworkComponents={{
							handleActionCellRender: handleActionCellRender,
							handleEmployeeNameCellRenderer: handleEmployeeNameCellRenderer,
							handleDateCellRenderer: handleDateCellRenderer
						}}
					>
						{user &&
						user.role === ROLES.super_admin &&
						((user.first_name === "Chitrak" && user.last_name === "Biswas") ||
							(user.first_name === "Anupam" && user.last_name === "Biswas") ||
							(user.first_name === "Rahul" && user.last_name === "Dutta") ||
							(user.first_name === "Suman" && user.last_name === "Dutta")) ? (
							<AgGridColumn
								field="employee.group_number"
								headerName="Group Number"
								floatingFilterComponentParams={{ suppressFilterButton: true }}
								suppressSizeToFit
							></AgGridColumn>
						) : null}
						<AgGridColumn
							field="member.location.location_name"
							headerName="Location"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
						></AgGridColumn>
						<AgGridColumn
							field="employee.member_id"
							headerName="Employee Id"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
						></AgGridColumn>
						<AgGridColumn
							field="member.role"
							headerName="Role"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
						></AgGridColumn>
						<AgGridColumn
							field="member"
							headerName="Employee Name"
							cellRenderer="handleEmployeeNameCellRenderer"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							suppressSizeToFit={true}
						></AgGridColumn>
						<AgGridColumn
							field="updatedAt"
							headerName="Request Date"
							cellRenderer="handleDateCellRenderer"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
						></AgGridColumn>
						<AgGridColumn
							field="action"
							headerName="Action"
							cellRenderer="handleActionCellRender"
							filter={false}
							suppressSizeToFit={true}
						></AgGridColumn>
					</AgGridReact>
				</div>
			</div>
		</>
	);
};

export default PersonalChangeRequestGrid;
